<template>
  <Layout class="layout-basic">
    <template #header>
      <Header />
    </template>

    <router-view />

    <template #footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>
export default {
  name: 'LayoutBasic',
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
// .layout-basic {
// .wrapper {
//   min-height: 100vh;
// }
// .header {
//   padding: 0;
//   background: #fff;
// }
// .main {
//   padding: 16px 100px;
// }
// .sider {
//   margin-right: 16px;
//   background: none;
//   overflow: 'auto';
// }
// .content {
//   background: #fff;
// }
// .footer {
//   text-align: center;
// }
// }
</style>
